import React, { useState } from 'react';
import styled from 'styled-components';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Navbar from '../Navbar';
import Footer from '../Footer';
import { useSelector } from 'react-redux';
import { selectUser } from '../../Redux/currentUserSlice';
import { useNavigate } from 'react-router-dom';
import IP_URL from '../connect';

const Container = styled.div`
  font-family: Arial, sans-serif;
  background-color: #f4f7fc;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  flex: 1;
  max-width: 900px;
  margin: 2rem auto;
  width: 95%;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const Section = styled.div`
  background: #fff;
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;

const SectionHeader = styled.h3`
  margin: 0;
  font-size: 1.3rem;
  color: #0283e5;
`;

const SectionDesc = styled.p`
  margin: 0;
  color: #555;
`;

const Button = styled.button`
  background-color: #0283e5;
  color: white;
  padding: 0.6rem 1.2rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  transition: 0.2s all ease;
  align-self: flex-start;

  &:hover {
    background-color: #0261b0;
  }
`;

const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 12px;
  width: 400px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const Input = styled.input`
  padding: 0.6rem;
  font-size: 1rem;
  border-radius: 6px;
  border: 1px solid #ccc;
`;

const ModalButton = styled(Button)`
  width: 100%;
`;

const Settings = () => {
  const navigate = useNavigate();

  const [showChangePassword, setShowChangePassword] = useState(false);
  const [showChangeEmail, setShowChangeEmail] = useState(false);

  const [otpPasswordSent, setOtpPasswordSent] = useState(false);
  const [passwordOtp, setPasswordOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const [newEmail, setNewEmail] = useState('');
  const [otpCurrentEmailSent, setOtpCurrentEmailSent] = useState(false);
  const [otpCurrentEmail, setOtpCurrentEmail] = useState('');

  const {token, uniqueKey, username, email} = useSelector(selectUser);
const [confirmNewEmail, setConfirmNewEmail] = useState('');


  // ======================
  // Change Password Handlers
  // ======================
  const handleOpenChangePassword = () => setShowChangePassword(true);
  const handleCloseChangePassword = () => {
    setShowChangePassword(false);
    setOtpPasswordSent(false);
    setPasswordOtp('');
    setNewPassword('');
    setConfirmPassword('');
  };

  const handleSendPasswordOtp = async () => {
    try {
      const res = await fetch(`${IP_URL}/settings/send-password-otp`, {
        method: 'POST',
        headers: { 
           'Authorization': `Bearer ${ token}`,
          'Content-Type': 'application/json' },
        body: JSON.stringify({ uniqueKey: uniqueKey })
      });
      const data = await res.json();
      if (res.ok) {
        toast.success('OTP sent to your email');
        setOtpPasswordSent(true);
      } else {
        toast.error(data.error || 'Failed to send OTP');
      }
    } catch (err) {
      toast.error('Failed to send OTP');
    }
  };

  const handleChangePassword = async () => {
    if (!passwordOtp || !newPassword || !confirmPassword) {
      toast.error('Please fill all fields');
      return;
    }
    if (newPassword !== confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }
    try {
      const res = await fetch(`${IP_URL}/settings/change-password`, {
        method: 'POST',
        headers: { 
          'Authorization': `Bearer ${ token}`,
          'Content-Type': 'application/json' },
        body: JSON.stringify({ otp: passwordOtp, newPassword })
      });
      const data = await res.json();
      if (res.ok) {
        toast.success('Password changed successfully');
        handleCloseChangePassword();
      } else {
        toast.error(data.error || 'Failed to change password');
      }
    } catch (err) {
      toast.error('Failed to change password');
    }
  };

  // ======================
  // Change Email Handlers
  // ======================
 
// Step 1: Verify OTP sent to current email
 const handleOpenChangeEmail = async () => {
    if (!email) {
      toast.error('Add email first!');
       navigate('/account'); // redirect if email is missing to add email
    
   
    return;
  }
    setShowChangeEmail(true);

    // Step 1: send OTP to current email
    try {
      const res = await fetch(`${IP_URL}/settings/send-current-email-otp`, {
        method: 'POST',
        headers: { 
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          uniqueKey,
          email
        })
      });
      const data = await res.json();
      if (res.ok) toast.success('OTP sent to your current email');
      else toast.error(data.error || 'Failed to send OTP');
    } catch (err) {
      toast.error('Failed to send OTP');
    }
  };


  //verify otp, update email
const handleVerifyAndUpdateEmail = async () => {
    

   if (!otpCurrentEmail) return toast.error('Enter OTP');
  if (!newEmail || !confirmNewEmail) return toast.error('Enter new email and confirm it');
  if (newEmail !== confirmNewEmail) return toast.error('Emails do not match');

  try {
    const res = await fetch(`${IP_URL}/settings/change-email-with-otp`, {
      method: 'POST',
      headers: { 
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ otp: otpCurrentEmail, newEmail, email, uniqueKey })
    });
    const data = await res.json();

    if (res.ok) {
      toast.success('Email updated successfully!');
      handleCloseChangeEmail();
    } else {
      toast.error(data.error || 'Failed to verify OTP or update email');
    }
  } catch (err) {
    toast.error('Failed to verify OTP or update email');
  }
};





  const handleCloseChangeEmail = () => {
    setShowChangeEmail(false);
    setOtpCurrentEmail('');
    setOtpCurrentEmailSent(false);
    setNewEmail('');
  };

  return (
    <Container>
      <Navbar showMenuButton={true} />
      <Content>
        <Section>
          <SectionHeader>Account Settings</SectionHeader>
          <SectionDesc>Update your profile information and credentials.</SectionDesc>
          <Button onClick={handleOpenChangePassword}>Change Password</Button>
          <Button onClick={handleOpenChangeEmail}>Change Email</Button>
        </Section>
      </Content>
      <Footer />
      <ToastContainer position="top-right" autoClose={4000} />

      {/* Change Password Modal */}
      {showChangePassword && (
        <ModalOverlay onClick={handleCloseChangePassword}>
          <ModalContent onClick={e => e.stopPropagation()}>
            <SectionHeader>Change Password</SectionHeader>

            {!otpPasswordSent ? (
              <ModalButton onClick={handleSendPasswordOtp}>Send OTP</ModalButton>
            ) : (
              <>
                <Input
                  type="text"
                  placeholder="Enter OTP"
                  value={passwordOtp}
                  onChange={e => setPasswordOtp(e.target.value)}
                />
                <Input
                  type="password"
                  placeholder="New Password"
                  value={newPassword}
                  onChange={e => setNewPassword(e.target.value)}
                />
                <Input
                  type="password"
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  onChange={e => setConfirmPassword(e.target.value)}
                />
                <ModalButton onClick={handleChangePassword}>Update Password</ModalButton>
              </>
            )}
            <Button onClick={handleCloseChangePassword}>Cancel</Button>
          </ModalContent>
        </ModalOverlay>
      )}
   {/* Change Email Modal */}
      {showChangeEmail && (
        <ModalOverlay onClick={handleCloseChangeEmail}>
          <ModalContent onClick={e => e.stopPropagation()}>
            <SectionHeader>Change Email</SectionHeader>

          {!otpCurrentEmailSent && (
  <>
    <p>OTP has been sent to your current email. Please verify to continue.</p>
    <Input
      type="text"
      placeholder="Enter OTP"
      value={otpCurrentEmail}
      onChange={e => setOtpCurrentEmail(e.target.value)}
    />
    <Input
      type="email"
      placeholder="Enter new email"
      value={newEmail}
      onChange={e => setNewEmail(e.target.value)}
    />
    <Input
      type="email"
      placeholder="Confirm new email"
      value={confirmNewEmail}
      onChange={e => setConfirmNewEmail(e.target.value)}
    />
    <ModalButton onClick={() => {
      if (newEmail !== confirmNewEmail) {
        toast.error('Emails do not match');
        return;
      }
      handleVerifyAndUpdateEmail();
    }}>
      Update Email
    </ModalButton>
  </>
)}

            <Button onClick={handleCloseChangeEmail}>Cancel</Button>
          </ModalContent>
        </ModalOverlay>
      )}

    </Container>
  );
};

export default Settings;
